module.exports = __webpack_public_path__ + "static/media/StrongboxLock.cf39735e.svg";